export default "__VITE_ASSET__8021dcef__"